import {Component} from '@angular/core';

@Component({
    templateUrl: './ErrorComponent.html',
    styleUrls: ['./ErrorComponent.scss'],
    standalone: false
})
export class ErrorComponent {

}
